export default __webpack_public_path__ + "static/media/beton_1.047aec81.webp";